
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.89 2.742h-.804a1.166 1.166 0 00-.25-.562.616.616 0 00-.5-.227c-.557 0-.925.453-1.102 1.36-.104.53-.177 1.47-.218 2.82.421.099.752.203.992.312.265.115.554.3.867.555l-.578.703C6.02 7.406 5.589 7.177 5 7.016c-.016.74-.023 1.575-.023 2.507 0 1.25-.055 2.378-.165 3.383.787-.146 1.357-.471 1.711-.976.459-.646.688-1.313.688-2 0-.365-.037-.685-.11-.961l-.765 1.43-.555-.29 1.203-2.351.438-.11 2.164 1.336-.305.54-1.336-.743c.115.406.172.795.172 1.164 0 .974-.31 1.857-.93 2.649-.53.672-1.359 1.083-2.484 1.234-.12.781-.276 1.48-.469 2.094-.49 1.578-1.356 2.367-2.601 2.367-.25 0-.469-.02-.656-.062a2.172 2.172 0 01-.547-.204l.101-1.539h.735c.067.25.166.456.296.618.136.161.326.242.57.242.548 0 .891-.568 1.032-1.703.063-.526.112-1.17.148-1.93-.546-.136-.97-.31-1.273-.524-.557-.38-.977-.843-1.258-1.39A4.02 4.02 0 01.36 9.945c0-.656.13-1.258.391-1.804.26-.552.672-1.024 1.234-1.414.5-.344 1.034-.55 1.602-.618.13-1.145.315-2.086.555-2.82C4.656 1.742 5.547.97 6.812.97c.183 0 .383.026.602.078.224.047.414.107.57.18l-.093 1.515zM1.939 8.023a3.262 3.262 0 00-.618 1.922c0 .74.209 1.393.625 1.961.271.37.737.682 1.399.938.02-.651.031-1.37.031-2.156 0-1.355.04-2.563.117-3.626-.661.115-1.18.435-1.554.961z","fill":"currentColor"}})])
          )
        }
      }
    